export default __webpack_public_path__ + "static/003-42fc2efa056a71e1da62cf04bbf2d772.jpg";